export class KaraokeAuthError extends Error {
  constructor(
    message: string,
    public readonly errors: Record<string, string[]> = {},
  ) {
    super(message);
  }
}
